/**
 * Returns an array of a given object's own enumerable string-keyed property [key, value] pairs.
 */
export const entries =
	typeof Object.entries === "function"
		? Object.entries
		: (target: Record<string, any>): [string, any][] =>
				Object.keys(target).map((key) => [key, target[key]]);
